var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 49H3.5C2.57 49 1.68 48.63 1.03 47.97C0.369999 47.31 0 46.42 0 45.5V8.75C0 7.82 0.369999 6.93003 1.03 6.28003C1.69 5.62003 2.58 5.25 3.5 5.25H5.25C6.18 5.25 7.06999 5.62003 7.71999 6.28003C8.37999 6.94003 8.75 7.83 8.75 8.75V45.5C8.75 46.43 8.37999 47.32 7.71999 47.97C7.05999 48.63 6.17 49 5.25 49Z",
    fill: "#9919F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.75C24.5 14.82 24.13 13.93 23.47 13.28C22.81 12.62 21.92 12.25 21 12.25H14C13.07 12.25 12.18 12.62 11.53 13.28C10.87 13.94 10.5 14.83 10.5 15.75V18.81C10.5 18.93 10.55 19.04 10.63 19.12C10.71 19.2 10.82 19.25 10.94 19.25H24.06C24.18 19.25 24.29 19.2 24.37 19.12C24.45 19.04 24.5 18.93 24.5 18.81V15.75Z",
    fill: "#DEB5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 45.5C10.5 46.43 10.87 47.32 11.53 47.97C12.19 48.63 13.08 49 14 49H21C21.93 49 22.82 48.63 23.47 47.97C24.13 47.31 24.5 46.42 24.5 45.5V42.22C24.5 42.16 24.48 42.11 24.44 42.07C24.4 42.03 24.34 42.01 24.29 42.01H10.73C10.67 42.01 10.62 42.03 10.58 42.07C10.54 42.11 10.52 42.17 10.52 42.22V45.5H10.5Z",
    fill: "#DEB5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.29 22.75H10.73C10.61 22.75 10.51 22.85 10.51 22.97V38.28C10.51 38.4 10.61 38.5 10.73 38.5H24.29C24.41 38.5 24.51 38.4 24.51 38.28V22.97C24.51 22.85 24.41 22.75 24.29 22.75Z",
    fill: "#DEB5FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 49H29.75C28.82 49 27.93 48.63 27.28 47.97C26.62 47.31 26.25 46.42 26.25 45.5V3.5C26.25 2.57 26.62 1.68003 27.28 1.03003C27.94 0.370029 28.83 0 29.75 0H33.25C34.18 0 35.07 0.370029 35.72 1.03003C36.38 1.69003 36.75 2.58 36.75 3.5V45.5C36.75 46.43 36.38 47.32 35.72 47.97C35.06 48.63 34.17 49 33.25 49Z",
    fill: "#9919F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4899 45.22L48.9599 8.03006C48.7999 6.32006 47.1099 5.08004 45.1799 5.26004L41.6999 5.59006C39.7799 5.77006 38.3499 7.31005 38.5099 9.02005L42.0399 46.21C42.1999 47.92 43.8899 49.16 45.8199 48.98L49.2999 48.6501C51.2199 48.4701 52.6499 46.93 52.4899 45.22Z",
    fill: "#DEB5FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCollection);
export default __webpack_public_path__ + "static/media/resource-collection.744b859ae09967c4d9527ddfd44c7b0d.svg";
export { ForwardRef as ReactComponent };